{
  "linkTo": "Establecer ubicación",
  "locationNotPinned": "Ubicación no fijada",
  "locationPinned": "Ubicación fijada",
  "locationPinnedExplanation": "\"Ubicación fijada\" significa que la ubicación del dispositivo se ha establecido manualmente y se utilizará en lugar de la ubicación GPS.",
  "locationUnpinnedExplanation": "\"Ubicación no fijada\" significa que la ubicación del dispositivo está siendo determinada por el chip GPS.",
  "pinnedLocation": "Ubicación fijada",
  "pinningExplanation": "Al fijar la ubicación del dispositivo, se anulará la lectura actual del chip GPS. Es posible que desees hacer esto si tu dispositivo tiene una recepción GPS deficiente de forma constante, por ejemplo, una bomba instalada dentro de un almacén con un techo de metal.",
  "tapTheMapToSetLocation": "Toque el mapa para establecer una ubicación permanente",
  "title": "Ubicación del dispositivo PIN",
  "unpinButton": "Claro"
}
